const {
    startOfWeek,
    endOfWeek,
    startOfYesterday,
    startOfMonth,
    endOfMonth,
    subMonths,
    startOfYear,
    endOfYear,
    subYears
} = require('date-fns');

export function getTodayDateFilterRange() {
    const today = new Date()
    return [today, today]
}
export function setYesterdayDateFilterRange() {
    const yesterday = startOfYesterday()
    return [yesterday, yesterday]
}
export function setThisWeekDateFilterRange() {
    const today = new Date()
    const currentWeekMonday = startOfWeek(today, {
        weekStartsOn: 1
    }); // Monday as the start of the week
    const currentWeekSunday = endOfWeek(today, {
        weekStartsOn: 1
    });
    return [currentWeekMonday, currentWeekSunday]
}
export function setLastWeekDateFilterRange() {
    const date = new Date()
    date.setDate(date.getDate() - 7)
    const lastWeekMonday = startOfWeek(date, {
        weekStartsOn: 1
    }); // Monday as the start of the week
    const lastWeekSunday = endOfWeek(date, {
        weekStartsOn: 1
    });
    return [lastWeekMonday, lastWeekSunday]
}
export function setThisMonthDateFilterRange() {
    let today = new Date()
    const currentMonthStart = startOfMonth(today)
    const currentMonthEnd = endOfMonth(today)
    return [currentMonthStart, currentMonthEnd]
}
export function setLastMonthDateFilterRange() {
    const date = subMonths(new Date, 1)
    const lastMonthStart = startOfMonth(date)
    const lastMonthEnd = endOfMonth(date)
    return [lastMonthStart, lastMonthEnd]
}
export function setThisYearDateFilterRange() {
    let today = new Date()
    const currentYearStart = startOfYear(today)
    const currentYearEnd = endOfYear(today)
    return [currentYearStart, currentYearEnd]
}
export function setLastYearDateFilterRange() {
    const date = subYears(new Date, 1)
    const lastYearStart = startOfYear(date)
    const lastYearEnd = endOfYear(date)
    return [lastYearStart, lastYearEnd]
}